module.exports = __webpack_public_path__ + "img/29.9b45e791.png";